import styles from "./about.module.css";
// import profile from "../assets/images/profile.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGithub, faTwitter } from "@fortawesome/free-brands-svg-icons";
import { faAt, faEnvelope, faFile } from "@fortawesome/free-solid-svg-icons";
import { toastOptions } from "../utilities/utilities";
import { toast } from "react-toastify";

export const About = ({ theme }) => {
      const handleCopyClick = async () => {
            try {
                  await navigator?.clipboard?.writeText(
                        "runtimeerror55@gmail.com"
                  );
                  toast.success("copied to clipboard", toastOptions);
            } catch (err) {
                  toast.error("Copy to clipboard failed", toastOptions);
            }
      };
      return (
            <>
                  <div
                        className={
                              styles["container-one"] +
                              " " +
                              styles["container-one-" + theme]
                        }
                  >
                        <div
                              className={
                                    styles["item"] +
                                    " " +
                                    styles["item-" + theme]
                              }
                        >
                              <img
                                    src={
                                          "https://res.cloudinary.com/diwrxz82u/image/upload/q_auto,f_auto/v1706687634/portfolio/profile_peqnmn.jpg"
                                    }
                                    alt="baymax"
                                    className={styles["profile"]}
                              ></img>
                              <div className={styles["social-links"]}>
                                    <a
                                          href="https://github.com/runtimeerror55"
                                          className={
                                                styles["social-link"] +
                                                " " +
                                                styles["social-link-" + theme]
                                          }
                                    >
                                          <FontAwesomeIcon
                                                icon={faGithub}
                                                size="lg"
                                          ></FontAwesomeIcon>
                                          <span
                                                className={
                                                      styles["social-name"]
                                                }
                                          >
                                                github
                                          </span>
                                    </a>
                                    <div
                                          className={
                                                styles["social-link"] +
                                                " " +
                                                styles["social-link-" + theme]
                                          }
                                          onClick={handleCopyClick}
                                    >
                                          <FontAwesomeIcon
                                                icon={faEnvelope}
                                                size="lg"
                                          ></FontAwesomeIcon>
                                          <span
                                                className={
                                                      styles["social-name"]
                                                }
                                          >
                                                gmail
                                          </span>
                                    </div>

                                    <a
                                          href="https://x.com/runtimeerror55"
                                          className={
                                                styles["social-link"] +
                                                " " +
                                                styles["social-link-" + theme]
                                          }
                                    >
                                          <FontAwesomeIcon
                                                icon={faTwitter}
                                                size="lg"
                                          ></FontAwesomeIcon>
                                          <span
                                                className={
                                                      styles["social-name"]
                                                }
                                          >
                                                twitter
                                          </span>
                                    </a>
                                    <a
                                          href="https://docs.google.com/document/d/1mjAPj5RaPFsQkXD5p8LeDgH8ZrNb5Ye5UMD1xZ5cjkE/edit"
                                          className={
                                                styles["social-link"] +
                                                " " +
                                                styles["social-link-" + theme]
                                          }
                                    >
                                          <FontAwesomeIcon
                                                icon={faFile}
                                                size="lg"
                                          ></FontAwesomeIcon>
                                          <span
                                                className={
                                                      styles["social-name"]
                                                }
                                          >
                                                resume
                                          </span>
                                    </a>
                              </div>
                        </div>

                        <div
                              className={
                                    styles["item-one"] + " " + styles["item"]
                              }
                        >
                              <p
                                    className={
                                          styles["introduction"] +
                                          " " +
                                          styles["introduction-" + theme]
                                    }
                              >
                                    Hi, this is aakash. I'm a passionate
                                    front-end developer with a keen eye for
                                    creating interactive, responsive, performant
                                    and visually appealing web applications.I
                                    love building products that can positively
                                    impact humanity and make the world a better
                                    place to live.
                                    <br></br> <br></br>I launched two successful
                                    products(web apps) that are innovative,
                                    usable, helpful to humanity and recieved
                                    extremely positive reviews from the users.
                                    Also shipped more features based on user
                                    feedback after the launch. Both combined
                                    achieved 700 visitors in the first 25 days
                                    of their public launch.
                                    <br></br>
                                    <ul>
                                          <li>
                                                <a
                                                      href="https://portfolio-frontend-nine-tau.vercel.app/projects/65e16b5f7b4bed0be60de733"
                                                      style={{
                                                            color: "inherit",
                                                            textDecoration:
                                                                  "underline",
                                                      }}
                                                >
                                                      M-tris(tetris 2.0)
                                                </a>
                                          </li>
                                          <li>
                                                <a
                                                      href="https://portfolio-frontend-nine-tau.vercel.app/projects/65e16b5f7b4bed0be60de735"
                                                      style={{
                                                            color: "inherit",
                                                            textDecoration:
                                                                  "underline",
                                                      }}
                                                >
                                                      minitype(touch typing 2.0)
                                                </a>
                                          </li>
                                    </ul>
                              </p>
                        </div>
                  </div>
            </>
      );
};
